export async function registerEvent(eventName) {
  const values = [eventName, new Date().toLocaleDateString("de-DE")];

  return fetch(
    "https://chevalier.group/webhook/trigger/60b63af2913c0d001af422c7",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ values }),
    }
  );
}
